import React from 'react';
import { Title2, Body1, makeStyles, tokens } from '@fluentui/react-components';

const useStyles = makeStyles({
  pageRoot: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    marginBottom: '16px',
  },
  comingSoon: {
    color: tokens.colorNeutralForeground3,
    marginTop: tokens.spacingVerticalS,
  },
});

export const NotificationsPage: React.FC = () => {
  const styles = useStyles();

  return (
    <div className={styles.pageRoot}>
      <div className={styles.header}>
        <Title2>Notifications</Title2>
      </div>
      <div className={styles.comingSoon}>
        <Body1>This feature is coming soon.</Body1>
      </div>
    </div>
  );
};
